<template>
  <div class="text-center mt-1">
    <a data-test-path="icon-attachment" :href="model.downloadUrl">
      <font-awesome-icon class="fa-2x" :icon="iconAttachment"/>
    </a>
  </div>
</template>

<script>

export default {
  name: "IconAttachment",

  async created()  {
    await this.loadIcon();
  },

  mounted(){
  },

  methods: {
    async loadIcon(){
      this.mimeType = this.model.data.mime

      if(this.mimeType === 'image/jpeg' || this.mimeType ==='image/png' || this.mimeType === 'image/gif' || this.mimeType === 'image/webp'){
        this.iconAttachment = 'file-image'
      }
      else if(this.mimeType === 'application/pdf'){
        this.iconAttachment = 'file-pdf'
      }
      else if(this.mimeType === 'application/msword'){
        this.iconAttachment = 'file-word'
      }
      else if(this.mimeType === 'video/mpeg' || this.mimeType === 'video/mp4' || this.mimeType === 'video/x-msvideo'){
        this.iconAttachment = 'file-video'
      }
      else if(this.mimeType === 'application/vnd.ms-powerpoint'){
        this.iconAttachment = 'file-powerpoint'
      }
      else if(this.mimeType === 'audio/mpeg' || this.mimeType === 'audio/wav'){
        this.iconAttachment = 'file-audio'
      }
      else if(this.mimeType === 'application/octet-stream'){
        this.iconAttachment = 'file-code'
      }
      else if(this.mimeType === 'application/vnd.ms-excel'){
        this.iconAttachment = 'file-excel'
      }
      else {
        this.iconAttachment = 'file'
      }
    },

  },

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
    mimeType: "",
    iconAttachment: "",
  })

};


</script>

